import { useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { useKiosks } from 'lib/hooks/queries/kiosks/useKiosks';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import Allowed from 'components/shared/Permissions/Allowed';
import state from 'components/state';

import KioskModal from './KioskModal';
import { DEFAULT_FILTERS } from './lib/defaultFilters';
import { generateColumnDefs } from './lib/helpers';

export default function PatientPayments() {
  const permissions = useRecoilValue(state.permissions);
  const outletContext = useOutletContext();
  const columnDefs = useMemo(() => generateColumnDefs(permissions), [permissions]);

  return (
    <Allowed requiredPermissions="kiosk.read" showMessage showIllustration>
      <AgTablePage
        ModalComponent={KioskModal}
        defaultColumns={columnDefs}
        defaultFilters={DEFAULT_FILTERS}
        useData={useKiosks}
        name="kiosks"
        queryParams={{ practiceId: outletContext?.practiceId }}
      />
    </Allowed>
  );
}
